<div gdColumns="repeat(auto-fill, minmax(250px, 1fr))" gdGap="10px" [formGroup]="form">
	<mat-slide-toggle formControlName="showWorkOrderNumber" class="custom-slider" labelPosition="before">Work Order
		Number
	</mat-slide-toggle>
	<mat-slide-toggle formControlName="showProjectNumber" class="custom-slider" labelPosition="before">Project Number
	</mat-slide-toggle>
	<mat-slide-toggle formControlName="showProjectManagerName" class="custom-slider" labelPosition="before">Project
		Manager Name
	</mat-slide-toggle>
	<mat-slide-toggle formControlName="showTermsAndConditions" class="custom-slider" labelPosition="before">Terms and
		Conditions
	</mat-slide-toggle>
	<mat-slide-toggle formControlName="showIsSupervisorJob" class="custom-slider" labelPosition="before">Is Supervisor
		Job
	</mat-slide-toggle>
	<mat-slide-toggle formControlName="showNetworkOrServiceOrder" class="custom-slider" labelPosition="before">Network
		or Service Order
	</mat-slide-toggle>
	<mat-slide-toggle formControlName="showIsThirdPartyJob" class="custom-slider" labelPosition="before">Is Third Party
		Job
	</mat-slide-toggle>
	<mat-slide-toggle formControlName="showAgreementNumber" class="custom-slider" labelPosition="before">Agreement
		Number
	</mat-slide-toggle>
	<mat-slide-toggle formControlName="showUpFolderNumber" class="custom-slider" labelPosition="before">UP Folder Number
	</mat-slide-toggle>
	<mat-slide-toggle formControlName="showNsActivityNumber" class="custom-slider" labelPosition="before">NS Activity
		Number
	</mat-slide-toggle>
	<mat-slide-toggle formControlName="showProtection" class="custom-slider" labelPosition="before">Protection
	</mat-slide-toggle>
	<mat-slide-toggle formControlName="showReferenceNumber" class="custom-slider" labelPosition="before">
		Reference Number
	</mat-slide-toggle>
	<mat-slide-toggle formControlName="showTrackID" class="custom-slider" labelPosition="before">
		Track ID
	</mat-slide-toggle>
	<mat-slide-toggle formControlName="showOrderNumber" class="custom-slider" labelPosition="before">
		Order Number
	</mat-slide-toggle>
	<mat-slide-toggle formControlName="showRequiresJobSetups" class="custom-slider" labelPosition="before">
		Requires Job Setups
	</mat-slide-toggle>
</div>